import React, { useState, useEffect } from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { batchDetails, batchDetailsForDataScience } from "../../constants/External";
import CheckEligiblityv2 from "../../DevopsV2/components/Popup/CheckEligiblityv2";
import { DATA_SCIENCE } from "../../constants/AzureDevops";

export default function AnnouncementBanner({course}) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);

      const diff = tomorrow - now;

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / 1000 / 60) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClaimClick = () => {
    setOpen(true);
  };

  return (
    <Box
      sx={{
        background: course === DATA_SCIENCE ?  "linear-gradient(90deg, #1a1030 0%, #1a1030 50%, #1a1030 100%)" : "linear-gradient(90deg, #8C00FF 0%, #A020F0 50%, #7B0FD0 100%)",
        py: { xs: 0.9, md: 1 },
        px: { xs: 1.5, md: "5%" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 1, md: 2 },
        flexWrap: { xs: "wrap", md: "nowrap" },
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(140, 0, 255, 0.25)",
        position: "relative",
        zIndex: 100,
      }}
    >
      {/* Left: Bell Icon + Batch Info - Hidden on mobile */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          gap: { xs: 0.8, md: 1.5 },
          flex: "0 0 auto",
          minWidth: 0,
          whiteSpace: "nowrap",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "11px", md: "14px" },
            fontWeight: 600,
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            letterSpacing: "0.3px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          ⏳ Next Batch: <b>{(course === DATA_SCIENCE ? batchDetailsForDataScience : batchDetails)[1].slice(0,6)} 2026</b> • Only 3 seats left
        </Typography>
      </Box>

      {/* Center: Countdown Timer */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 0.5, md: 1.2 },
          flex: { xs: "0 0 auto", md: "0 1 auto" },
          minWidth: 0,
          whiteSpace: "nowrap",
          borderRadius: "24px",
          px: { xs: 1, md: 2 },
          opacity: 0.9,
          background: "rgba(255,255,255,0.18)",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "12px", md: "13px" },
            fontWeight: 600,
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          🎓  35% Scholarship ends in 
        </Typography>
        <Box sx={{ display: "flex", gap: 0.2, alignItems: "center" }}>
          {[
            { label: timeLeft.hours },
            { label: timeLeft.minutes },
            { label: timeLeft.seconds },
          ].map((item, idx) => (
            <Box key={idx} sx={{ display: "flex", alignItems: "baseline", gap: 0.15 }}>
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "14px" },
                  fontWeight: 700,
                  color: "#fff",
                  fontFamily: "monospace",
                  minWidth: { xs: "12px", md: "22px" },
                  textAlign: "center",
                }}
              >
                {String(item.label).padStart(2, "0")}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "8px", md: "12px" },
                  fontWeight: 600,
                  color: "#fff",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {item.unit}
              </Typography>
              {idx < 2 && (
                <Typography sx={{ color: "#fff", mx: 0.15, fontSize: "14px", fontWeight: 600 }}>
                  :
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Box>

      {/* Right: CTA Button */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "0 0 auto" },
          display: "flex",
          justifyContent: "center",
          minWidth: "auto",
        }}
      >
        <Button
          onClick={handleClaimClick}
          sx={{
            background: "rgb(255, 107, 53)",
            color: "#fff",
            fontWeight: 700,
            fontSize: { xs: "12px", md: "12px" },
            px: { xs: 1.5, md: 1.5 },
            py: { xs: 0.2, md: 0.3 },
            borderRadius: "24px",
            textTransform: "none",
            whiteSpace: "nowrap",
            fontFamily: "Poppins, sans-serif",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 12px rgba(255, 215, 0, 0.3)",
            "&:hover": {
              background: "linear-gradient(135deg, #FFA500 0%, #FF8C00 100%)",
              boxShadow: "0 6px 20px rgba(255, 215, 0, 0.4)",
              transform: "translateY(-2px)",
            },
          }}
        >
          Claim Scholarship →
        </Button>
      </Box>

      <CheckEligiblityv2
        isSmallScreen={isMobile}
        open={open}
        onClose={() => setOpen(false)}
      />
    </Box>
  );
}
